export const defaultScopeId = "v3.notificationsettings";

export const SUBSCRIBE = "NOTIFICATION_SETTINGS/SUBSCRIBE";
export const UNSUBSCRIBE = "NOTIFICATION_SETTINGS/UNSUBSCRIBE";
export const UPDATE_REQUESTED = "NOTIFICATION_SETTINGS/UPDATE_REQUESTED";
export const UPDATE_SUCCEEDED = "NOTIFICATION_SETTINGS/UPDATE_SUCCEEDED";
export const UPDATE_FAILED = "NOTIFICATION_SETTINGS/UPDATE_FAILED";
export const LOAD_REQUESTED = "NOTIFICATION_SETTINGS/LOAD_REQUESTED";
export const LOAD_SUCCEEDED = "NOTIFICATION_SETTINGS/LOAD_SUCCEEDED";
export const LOAD_FAILED = "NOTIFICATION_SETTINGS/LOAD_FAILED";

// eslint-disable-next-line max-statements
export default (state = {
    errors: [],
    isInitialised: false,
    loading: false,
    notificationSettings: {},
    subscriptions: 0,
    updating: false,
}, { type, data }) => {
    switch (type) {
    case SUBSCRIBE: {
        ++state.subscriptions;
        state.loading = true;
        return state;
    }
    case UNSUBSCRIBE: {
        --state.subscriptions;
        return state;
    }
    case LOAD_REQUESTED: {
        state.loading = true;
        return state;
    }
    case UPDATE_REQUESTED: {
        state.updating = true;
        return state;
    }
    case LOAD_SUCCEEDED: {
        for (const [ settingType, value ] of Object.entries(data)){
            if (!settingType.startsWith("_") && value != null){
                state.notificationSettings[settingType] = value;
            }
        }
        state.loading = false;
        state.isInitialised = true;
        return state;
    }
    case UPDATE_SUCCEEDED: {
        for (const [ settingType, value ] of Object.entries(data)){
            if (!settingType.startsWith("_") && value != null){
                state.notificationSettings[settingType] = value;
            }      
        }
        state.updating = false;
        return state;
    }
    case LOAD_FAILED: {
        state.errors.push({ ...data, type });
        state.loading = false;
        return state;
    }
    case UPDATE_FAILED: {
        state.errors.push({ ...data, type });
        state.updating = false;
        return state;
    }
    default: return state;
    }
};

export const subscribeNotificationSettings = userId => ({ type: SUBSCRIBE, data: { userId } });
export const unsubscribeNotificationSettings = userId => ({ type: UNSUBSCRIBE, data: { userId } });
export const requestNotificationSettingsLoad = (data, resolve, reject) => ({ type: LOAD_REQUESTED, data, resolve, reject });
export const succeedNotificationSettingsLoad = data => ({ type: LOAD_SUCCEEDED, data });
export const failNotificationSettingsLoad = data => ({ type: LOAD_FAILED, data });
export const requestNotificationSettingsUpdate = (data, resolve, reject) => ({ type: UPDATE_REQUESTED, data, resolve, reject });
export const requestNotificationSettingsUpdateMany = (data, resolve, reject) => ({ type: UPDATE_REQUESTED, data, resolve, reject });
export const succeedNotificationSettingsUpdate = data => ({ type: UPDATE_SUCCEEDED, data });
export const failNotificationSettingsUpdate = data => ({ type: UPDATE_FAILED, data });
